import {useEffect, useState} from 'react';

import {checkAdminIpAccess} from '@/api/internal/system';

interface IpCheckResult {
  isAllowed: boolean;
  isLoading: boolean;
  clientIp: string | null;
}

export const useIpCheck = (): IpCheckResult => {
  const [isAllowed, setIsAllowed] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [clientIp, setClientIp] = useState<string | null>(null);

  useEffect(() => {
    const checkIpAccess = async () => {
      try {
        const data = await checkAdminIpAccess();
        setIsAllowed(data.allowed);
        setClientIp(data.clientIp);
      } catch (error) {
        console.error('IP 체크 실패:', error);
        setIsAllowed(false);
      } finally {
        setIsLoading(false);
      }
    };

    checkIpAccess();
  }, []);

  return {isAllowed, isLoading, clientIp};
};
